import { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Layout } from 'antd';
import UserMenu from '../../components/UserMenu';
import Sidebar from '../../components/Sidebar';
import Container from '../../components/Container';
import SidebarHeader from '../../components/SidebarHeader';
import GlobalLoader from '../../components/GlobalLoader';
import { ToastContainer } from 'react-toastify';
import { Close } from '../../components/Svg/Svg';
import { useSelector, useDispatch } from 'react-redux';
import { getShowGlobalLoader } from '../../redux/slices/appSlice';
import { getAuthenticatedUser } from '../../redux/slices/authSlice';

const { Sider, Content } = Layout;

export default function MainLayout() {
    const showGlobalLoader = useSelector(getShowGlobalLoader);
    const dispatch = useDispatch();
    const location = useLocation();

    useEffect(() => {
        if (location.pathname === '/') return;
        dispatch(getAuthenticatedUser());
    }, [dispatch, location.pathname]);
    return (
        <>
            <div>
                <div>
                    <Layout>
                        <Sider
                            trigger={null}
                            className="ant-sider-fixed"
                            width={280}
                        >
                            <SidebarHeader />
                            <Sidebar />
                        </Sider>
                        <Layout className="site-layout">
                            <Content className="site-layout-content">
                                <Container>
                                    <UserMenu />
                                    <Outlet />
                                </Container>
                            </Content>
                        </Layout>
                    </Layout>
                </div>
            </div>
            <GlobalLoader isLoading={showGlobalLoader} />
            <ToastContainer
                position="top-right"
                autoClose={5000}
                hideProgressBar
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable={false}
                pauseOnHover
                icon={false}
                closeButton={<Close />}
            />
        </>
    );
}
